import Vue from 'vue'
import { normalize } from 'normalizr'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'
import { relativeSchema } from '@/schema/relative'
import { RelativeEntities } from '@/schema/relative/types'
import { Relative } from '@/types/user'
import store from '@/store'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  // relativePatient: null,
  relatives: {},
  sort: []
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  // relativePatient: ({ relativePatient }) => relativePatient,
  relatives: state => state.relatives,
  relativeList: state =>
    Object.entries(state.relatives).map(([key, val]) => val),
  activeRelativeList: state =>
    Object.entries(state.relatives)
      .map(([key, val]) => val)
      .filter(r => r.isActive),
  sort: state => (Array.isArray(state.sort) ? state.sort : [])
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  // updatePatient: (state, patient) => {
  //   state.relativePatient = patient
  // },

  clear: state => {
    state.relatives = {}
    state.sort = []
  },

  update: (state, { id, relative }) => {
    const current = state.relatives[id]
    Vue.set(state.relatives, id, Object.assign({}, current, relative))
  },

  updateList: (state, { relatives, sort = [] }) => {
    state.relatives = relatives
    state.sort = sort
  },

  delete: (state, { id }) => {
    const relatives = Object.assign({}, state.relatives)
    delete relatives[id]
    state.relatives = relatives
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async update({ commit }, { relativeId }) {
    const res = await Vue.$api.user.relative({ relativeId })
    const resRelative = { ...res, isPatientRelative: true }
    const { entities } = normalize<Relative, RelativeEntities, number>(
      resRelative,
      relativeSchema
    )

    commit('update', {
      relative: entities.relatives[relativeId],
      id: relativeId
    })
  },

  async updateList({ commit }) {
    const res = await Vue.$api.user.relativeList()
    const resRelatives = res.map(r => ({ ...r, isPatientRelative: true }))
    const { result, entities } = normalize<
      Relative[],
      RelativeEntities,
      number[]
    >(resRelatives, [relativeSchema])

    let { relatives } = entities
    relatives = relatives || {}

    res.forEach(relative => {
      store.commit('onlineStatus/setOnlineStatus', {
        [relative.id]: {
          user: relative.id,
          isOnline: !!relative.isOnline
        }
      })
    })

    commit('updateList', {
      sort: result,
      relatives
    })
  },

  async delete({ commit }, { id }) {
    await Vue.$api.user.deleteRelative({ relativeId: id })
    commit('delete', { id })
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
